module.exports = __webpack_public_path__ + "img/1.4fe52eab.png";